import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CommsService } from '../../services/comms.service';
import { Router } from '@angular/router';
import { SessionBookingVM } from '../models/SessionBookingVM';
import { Observable } from 'rxjs';
import { InstantMessageVM } from '../models/InstantMessageVM';
import * as moment from 'moment';
import { SessionInfoVM } from '../models/SessionInfoVM';

@Component({
  selector: 'im',
  templateUrl: './im.component.html',
  styleUrls: ['./im.component.scss']
})
export class IMComponent implements OnInit {

  @ViewChild('scrollChat') private chatContainer: ElementRef;
  comms: CommsService;
  audio: any = new Audio();
  messagebox: string = "";
  chatHistory: InstantMessageVM[] = [];
  session: SessionInfoVM = new SessionInfoVM();

  listenLock: boolean = false;
  sendingMessage: boolean = false;
  disableScrollDown = false;
  typingIdleTimeStamp: moment.Moment = null;

  constructor(
    private commsService: CommsService,
    private router: Router
  ) {
    this.comms = commsService;
    this.session = commsService.activeSessionInfo;
  }

  ngOnInit(): void {
    this.audio.src = '/beep.mp3';
    this.audio.load();

    this.commsService.getChatHistory()
      .subscribe(
        (data) => {
          this.chatHistory = [];
          data.messages.forEach((value) => {
            this.chatHistory.push(value);
          });
          setTimeout(() => {
            this.scrollToBottom(false);
          }, 500);

          this.startChatListener();
        },
        error => this.handleError(error));
  }

  startChatListener() {
    setTimeout(() => {
      var self = this;
      if (!self.sendingMessage && !self.listenLock) {
        self.listenLock = true;
        console.log('checking for new messages');
        self.receiveMessage(self.releaseListenLock);
      }

      self.startChatListener();
    }, 3000);
  }

  receiveMessage(releaseLock: Function) {
    try {
      let modifiedSince: Date = (this.chatHistory.length < 1) ? new Date(this.session.date) : new Date(this.chatHistory[this.chatHistory.length - 1].timeStamp);
      let isTyping: boolean = moment.duration(moment().diff(this.typingIdleTimeStamp)).asSeconds() < 10;
      this.commsService.listen(modifiedSince, isTyping)
        .subscribe(
          (data) => {
            data.messages.forEach((value) => {
              var found = false;
              this.chatHistory.forEach((cachedMessage) => {
                if (cachedMessage.id === value.id) {
                  found = true;
                }
              });

              try {
                if (!found) {
                  //display message
                  this.chatHistory.push(value);

                  //audio beep
                  this.audio.play();

                  //hide other typing notification
                  this.comms.isOtherPartyTyping = false;
                }
              } catch { ; }

              setTimeout(() => {
                this.scrollToBottom(!found);
              }, 500);

            });
          },
          (error) => {
            this.handleError(error)
          },
          () => {
            releaseLock();
          }
        );
    }
    catch {
      releaseLock();
    }
  }

  sendMessage() {
    if (this.messagebox != null && this.messagebox.length > 0) {
      this.sendingMessage = true;
      this.commsService.sendIM(this.messagebox)
        .subscribe(
          (returnValue) => {
            if (!returnValue) {
              //error occured
            }
            else {
              //load messages
            }
          },
          error => { },
          () => { this.receiveMessage(this.releaseSendingMessageLock); }
        );
      this.messagebox = "";
    }
  }

  enterSendMessage(event) {
    if (event.key === "Enter") {
      this.sendMessage();
    }
    else {
      if (this.messagebox.length > 0) {
        this.typingIdleTimeStamp = moment();
      }
    }
  }

  releaseListenLock = () => { this.listenLock = false; }
  releaseSendingMessageLock = () => { this.sendingMessage = false; }

  handleError(arg0: any): any {
    console.log(arg0);
  }

  onScroll() {
    let element = this.chatContainer.nativeElement;
    let atBottom = element.scrollHeight - element.scrollTop === element.clientHeight;
    if (this.disableScrollDown && atBottom) {
      this.disableScrollDown = false;
    } else {
      this.disableScrollDown = true;
    }
  }

  scrollToBottom(force: boolean) {

    if (this.disableScrollDown && !force) {
      return;
    }
    try {
      this.chatContainer.nativeElement.scrollTop = this.chatContainer.nativeElement.scrollHeight;
    } catch (err) { }
  }

}
